import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';

export default function LoginPage({ onLogin }) {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const result = await login(username.trim(), password);
      onLogin(result);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-logo">PAR Grand Hotel</div>
        <div className="login-tagline">Hotel Management System</div>

        {error && (
          <div className="login-error" style={{ marginBottom: 12 }}>
            ⚠️ {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div className="field">
            <label>Username</label>
            <input id="login-username" value={username} onChange={e => setUsername(e.target.value)} placeholder="Username" autoFocus required />
          </div>
          <div className="field">
            <label>Password</label>
            <input id="login-password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" required />
          </div>
          <button id="login-submit" type="submit" className="btn btn-gold" disabled={loading} style={{ justifyContent: 'center', marginTop: 4 }}>
            {loading ? '⏳ Signing in…' : '🔐 Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
